module.exports = __webpack_public_path__ + "static/media/xing.1aae2673.svg";